"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.batchReducer = exports.batchActionCreator = exports.BATCH = void 0;

var _browserApiUtils = require("@hh.ru/browser-api-utils");

var BATCH = 'BATCHING_ACTIONS';
exports.BATCH = BATCH;

var batchActionCreator = function batchActionCreator(actions) {
  return {
    type: BATCH,
    payload: actions
  };
};

exports.batchActionCreator = batchActionCreator;

var batchReducer = function batchReducer(rootReducer) {
  return function (state, action) {
    if (action.type === BATCH) {
      return action.payload.reduce(function (state, action) {
        try {
          return rootReducer(state, action);
        } catch (e) {
          _browserApiUtils.Debug.log('out error', e, {
            actionWhichCausedError: action
          });

          return state;
        }
      }, state);
    }

    return rootReducer(state, action);
  };
};

exports.batchReducer = batchReducer;

var _default = function _default(_ref) {
  var dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (Array.isArray(action)) {
        if (action.find(function (action) {
          return action instanceof Function;
        })) {
          _browserApiUtils.Debug.log('out error', 'Thunks in batch actions are forbidden', action);
        }

        return dispatch(batchActionCreator(action));
      }

      return next(action);
    };
  };
};

exports["default"] = _default;